import React, { lazy, Component } from 'react';
import { Zap } from 'lucide-react';
import { Product, WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface ProductCardProps {
  product: Product;
  onClick: () => void;
}
export function ProductCard({
  product,
  onClick
}: ProductCardProps) {
  const waMsg = encodeURIComponent(`Hola! Quiero el ${product.name} con 20% OFF — precio $${product.currentPrice}`);
  const waLink = `https://wa.me/${WA_NUMBER}?text=${waMsg}`;
  return <div onClick={onClick} className="bg-dark-600 border border-dark-400 rounded-lg overflow-hidden transition-all duration-300 cursor-pointer relative group hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(212,160,23,0.2)] hover:border-alphaGold" data-id="element-386" data-mp="pawumexfmjt0">
      <div className="absolute top-[15px] left-[15px] bg-alphaGold text-white text-[0.75rem] font-black py-1 px-3 rounded-sm tracking-[1px] z-10" data-id="element-387" data-mp="2v4o4qla5bsxv">
        20% OFF
      </div>

      <div className="w-full h-52 overflow-hidden bg-white flex items-center justify-center relative" data-id="element-388" data-mp="303zlhuaiiyfg">
        <img src={product.image} alt={product.name} loading="lazy" className={`max-w-full max-h-full object-contain p-4 transition-transform duration-300 ${product.imageZoom ? 'scale-[1.3] group-hover:scale-[1.37]' : 'group-hover:scale-105'}`} style={product.imageCropPercent ? {
        clipPath: `inset(0 ${product.imageCropPercent}% 0 ${product.imageCropPercent}%)`
      } : undefined} onError={e => {
        e.currentTarget.src = product.fallbackImage;
      }} data-id="element-389" data-mp="3lsyjti7i0dgo" />
      </div>

      <div className="p-[25px]" data-id="element-390" data-mp="3qpfbgmdwp9yi">
        <h3 className="text-[1.05rem] font-extrabold uppercase tracking-[1px] mb-2.5 text-white" data-id="element-391" data-mp="2k9v29da6erk8">
          {product.name}
        </h3>
        <p className="text-[0.88rem] text-[#999] leading-[1.65] mb-[15px]" data-id="element-392" data-mp="2f9qkzl1g1ssy">
          {product.description.substring(0, 100)}...
        </p>

        <ul className="list-none mb-[18px] space-y-1.5" data-id="element-393" data-mp="2gpum8nsssoq7">
          {product.benefits.slice(0, 3).map((benefit, idx) => <li key={idx} className="text-[0.82rem] text-[#bbb] pl-[18px] relative" data-id="element-394" data-mp="27r94uvz2bfr0" data-mpi={idx}>
              <span className="absolute left-0 text-alphaGold font-black" data-id="element-395" data-mp="2cpkh1dcty2ce">
                ✓
              </span>
              {benefit}
            </li>)}
        </ul>

        <div className="flex items-center gap-3 mb-[18px] flex-wrap" data-id="element-396" data-mp="22rwc5ulifegi">
          <span className="text-[1.8rem] font-black text-alphaGold" data-id="element-397" data-mp="22u8yejyawazd">
            ${product.currentPrice.toLocaleString('es-UY')}
          </span>
        </div>

        <a href={waLink} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="flex items-center justify-center gap-2 bg-whatsapp text-white text-[0.9rem] font-extrabold py-3.5 px-5 rounded uppercase tracking-[1px] transition-all duration-300 w-full hover:bg-whatsappDark hover:scale-[1.02]" data-id="element-398" data-mp="1t3eazc9bj5cc">
          <WhatsAppIcon data-id="element-399" data-mp="vhl6ccqnbijk" />
          Pedir por WhatsApp
        </a>

        <div className="flex items-center gap-1.5 mt-3 text-[0.78rem] text-alphaGold font-semibold" data-id="element-400" data-mp="1ae2ktcu4tdac">
          <Zap className="w-3.5 h-3.5" data-id="element-401" data-mp="15f95devabc7j" /> Stock limitado — Oferta por tiempo
          limitado
        </div>
      </div>
    </div>;
}